export default [
  'Phone call',
  'Personal email',
  'Text',
  'In-person meeting',
  'Other'
]
